import { createBrowserRouter } from "react-router-dom";
import { DefaultLayout } from "./layouts";
import { DashboardLayout } from "./layouts/DashboardLayout";
import { LandingPage } from "./pages/LandingPage";
import { RegisterPage } from "./pages/RegisterPage";
import { SignInPage } from "./pages/SignInPage";
import { ForgotPasswordPage } from "./pages/ForgotPasswordPage";
import { ResetPasswordPage } from "./pages/ResetPasswordPage";
import { ContactPage } from "./pages/ContactPage";
import { TermsAndConditionsPage } from "./pages/TermsAndConditionsPage";
import { PrivacyPolicyPage } from "./pages/PrivacyPolicyPage";
import { ErrorPage } from "./pages/ErrorPage";
import { SavedPostsPage } from "./pages/Dashboard/SavedPostsPage";
import { AccountSettingsPage } from "./pages/Dashboard/AccountSettingsPage";
import ProtectedRoute from "./components/ProtectedRouteWrapper";
import { PublicRoute } from "./components/PublicRouteWrapper";

const router = createBrowserRouter([
  {
    path: "/",
    element: <DefaultLayout />,
    errorElement: <ErrorPage />,
    children: [
      { index: true, element: <LandingPage /> },
      {
        path: "signin", element: <PublicRoute>
          <SignInPage />
        </PublicRoute>
      },
      {
        path: "register", element: <PublicRoute>
          <RegisterPage />
        </PublicRoute>
      },
      {
        path: "forgotpassword", element: <PublicRoute>
          <ForgotPasswordPage />
        </PublicRoute>
      },
      {
        path: "resetpassword", element: <PublicRoute>
          <ResetPasswordPage />
        </PublicRoute>
      },
      { path: "contact", element: <ContactPage /> },
      { path: "terms-and-conditions", element: <TermsAndConditionsPage /> },
      { path: "privacy-policy", element: <PrivacyPolicyPage /> },
    ],
  },
  {
    path: "/dashboard",
    element: <ProtectedRoute />, // protect everything inside
    children: [
      {
        element: <DashboardLayout />, // layout for dashboard
        children: [
          { index: true, element: <SavedPostsPage /> },
          { path: "settings", element: <AccountSettingsPage /> },
        ],
      },
    ],
  },
]);

export default router;
